import autobind from 'autobind-decorator';
import * as React from 'react';
import { DropdownInput, Input } from '@shared/ui-components';

import { BillingCountryModel } from '../../../interfaces/billing-country-model';
import { Styled } from './styled';

interface Props {
  availableCountries: BillingCountryModel[];
  selectedCountryId?: string;
  vatNumber: string | null;
  vatNumberErrorText?: string;
  onCountryChange: (countryId: string) => void;
  onVatNumberChange: (countryId: string) => void;
}

export class BillingAddress extends React.Component<Props> {
  public render(): JSX.Element {
    const { selectedCountryId, availableCountries, vatNumberErrorText } = this.props;
    const countryNames = availableCountries.map(x => x.name);
    const selectedCountryIndex = availableCountries.findIndex(x => x.id === selectedCountryId);
    const selectedCountry = availableCountries[selectedCountryIndex];
    const isVatNumberAvailable = selectedCountry && selectedCountry.allowVatNumber;

    const isVatNumberInvalid = !!vatNumberErrorText;

    return (
      <Styled.Container>
        <Styled.Column>
          <DropdownInput
            header={'Country'}
            elements={countryNames}
            activeElementIndex={selectedCountryIndex}
            onClick={this.selectCountry}
            closeAfterClick={true}
            backgroundColor='background'
          />
        </Styled.Column>
        {
          isVatNumberAvailable && (
            <Styled.Column>
              <Styled.VatCountryLabel>
                {`${selectedCountry.id} |`}
              </Styled.VatCountryLabel>
              <Styled.InputContainer>
                <Input
                  width={'180px'}
                  type={'text'}
                  text={'VAT NUMBER'}
                  maxLength={20}
                  input={{
                    value: this.props.vatNumber,
                    onChange: this.vatNumberChanged,
                  }}
                  isInvalid={isVatNumberInvalid}
                />
                <Styled.ValidationError>{vatNumberErrorText}</Styled.ValidationError>
              </Styled.InputContainer>
            </Styled.Column>
          )
        }
      </Styled.Container>
    );
  }

  @autobind
  private selectCountry(index: number): void {
    const selectedCountry = this.props.availableCountries[index];
    this.props.onCountryChange(selectedCountry.id);
    if (!selectedCountry || !selectedCountry.allowVatNumber) {
      this.props.onVatNumberChange(null);
    }
  }

  @autobind
  private vatNumberChanged(event: any): void {
    this.props.onVatNumberChange(event.target.value);
  }
}
